module.exports = __webpack_public_path__ + "static/img/gzh.ef87f280.png";